import frequencyParse from './frequencyParse';
import crossParse from './crossParse';
import areaListParse from './areaListParse';
import multiDimensionParse from './multiDimensionParse';

export default function parseDataTable(dataJSON, options = {}) {
	let processedData = {};

	// Extract dimension order option (for multi-dimensional tables)
	const { dimensionOrder = [2, 1, 0] } = options;

	// Redatam X fix
	try {
		if (dataJSON?.metadata?.dimensions) {
			dataJSON.metadata.dimensions.forEach((dim) => {
				if (dim?.labels?.length < dim?.values?.length) {
					dim.labels = dim?.values.map((e) => String(e));
				}
			});
		}
	} catch (error) {
		console.log(error);
	}

	if (dataJSON.type === 'AREALIST') {
		processedData = areaListParse(dataJSON);
	} else if (dataJSON.type === 'CROSSTABS' || dataJSON.type === 'FREQUENCY' || dataJSON.type === 'TABOP') {
		if (dataJSON.metadata.dimensions.length === 1) {
			processedData = frequencyParse(dataJSON);
		} else if (dataJSON.metadata.dimensions.length === 2) {
			processedData = crossParse(dataJSON, false);
		} else if (dataJSON.metadata.dimensions.length >= 3) {
			processedData = multiDimensionParse(dataJSON, dimensionOrder);
		}
	}

	return processedData;
}
